// List of  All Categories
const pages = [
  { english: 'home', malayalam: 'ഹോം' },
  { english: 'kerala', malayalam: 'കേരളം' },
  { english: 'national', malayalam: 'രാജ്യം' },
  { english: 'world', malayalam: 'ലോകം' },
  { english: 'cinema', malayalam: 'സിനിമ' },
  { english: 'sports', malayalam: 'കായികം' },
  { english: 'life', malayalam: 'ജീവിതം' },
  { english: 'business', malayalam: 'ബിസിനസ്സ്' },
  { english: 'astrology', malayalam: 'ജ്യോതിഷം' },
  { english: 'auto', malayalam: 'വാഹനം' },
  { english: 'analysis', malayalam: 'വിശകലനം' },
  { english: 'culture', malayalam: 'സാംസ്കാരികം'}
];

export default pages;